import React from "react";
import {FaAsterisk} from "react-icons/fa";

const AsteriskIcon = () => {
  return (
    <span className="ml-1">
      <FaAsterisk
        aria-hidden="true"
        color="#DC0000"
        data-cy="asterisk-icon"
        fontSize={7}
      />
    </span>
  );
};

export default AsteriskIcon;
